// extracted by mini-css-extract-plugin
module.exports = {"trigger":"facet-FacetGroupMenuTrigger__trigger--jSUU6"};